<template>
  <div class="brand-logo relative inline-block leading-none" :class="$attrs.class">
    <img
      src="/icons/logo-source.png?v=cutout4"
      alt=""
      :class="[imgClass, 'brand-logo__image']"
      :fetchpriority="fetchpriority"
      draggable="false"
      decoding="async"
    >
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    imgClass: {
      type: String,
      default: 'block h-full w-full object-contain brand-logo__image',
    },
    fetchpriority: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style scoped>
.brand-logo {
  background: transparent;
}

.brand-logo__image {
  background: transparent;
  filter: none;
}
</style>
